<template>
  <div>
    <div class="container">
      <div class="inner">
        <div class="back-wrapper" v-if="isUserLogged">
          <button class="secondary back" @click="goToUserData">{{ $t('view.component.common.buttonBack') }}</button>
        </div>
        <h1 class="main-title">{{ $t('view.component.user.changePassword.header') }}</h1>
        <UserFormChangePassword :title="$t('view.component.user.changePassword.title')"
                                :token="token" />
      </div>
    </div>
  </div>
</template>

<script>
import { ROUTING } from '@/orange/const/routing.const'
import UserFormChangePassword from '@/orange/components/User/FormChangePassword'
import UserChangePasswordMixin from '@/common/mixins/views/UserChangePassword.mixin'

export default {
  name: 'UserChangePasswordView',
  mixins: [UserChangePasswordMixin],
  components: { UserFormChangePassword },
  methods: {
    goToUserData () {
      this.$router.push(ROUTING.user.data)
    },
    goToHomePage () {
      this.$router.push(ROUTING.main)
    }
  }
}
</script>

<style lang="scss" src="../../assets/scss/components/_login-register.scss" scoped></style>
